const e = "styles-module__menuItemDropdown___exhI6", o = "styles-module__innerWrapper___mir35", n = "styles-module__dropdownGrid___g7NT4", _ = "styles-module__dropdownImageWrapper___IkHdh", t = "styles-module__areaOfLawImageContainer___-8zLz", s = "styles-module__menuDropdownBGIcon___eUOAB", a = "styles-module__areaOfLawImage___X9yyo", d = "styles-module__defaultImage___-nQpJ", m = "styles-module__imageVisible___3q19Q", l = "styles-module__imageHidden___SGf6B", r = "styles-module__mainMenuLink___uNbHy", i = "styles-module__areasMenuModal___Rmxrs", u = "styles-module__closeWrapper___jiEyK", p = "styles-module__closeButton___BHG-Y", c = "styles-module__hidden___zm9iW", I = "styles-module__activeIcon___PQK-7", w = "styles-module__modalContent___kC3-s", y = "styles-module__areasList___K-Z9Y", g = "styles-module__mobileBGIcon___W3HZq", D = "styles-module__headingContainer___6HRLX", L = "styles-module__arrowIcon___HfelO", W = "styles-module__pageTitle___zZ38P", G = "styles-module__menuDropdownItem___RuGGa", T = "styles-module__menuDropdownItemTitle___Z7Iua", f = "styles-module__menuDropdownItemDescription___oDMyr", B = "styles-module__menuDropdownItemTitleWrapper___LilM0", M = "styles-module__gradientText___0aQdb", C = {
  menuItemDropdown: e,
  innerWrapper: o,
  dropdownGrid: n,
  dropdownImageWrapper: _,
  areaOfLawImageContainer: t,
  menuDropdownBGIcon: s,
  areaOfLawImage: a,
  defaultImage: d,
  imageVisible: m,
  imageHidden: l,
  mainMenuLink: r,
  areasMenuModal: i,
  closeWrapper: u,
  closeButton: p,
  hidden: c,
  activeIcon: I,
  modalContent: w,
  areasList: y,
  mobileBGIcon: g,
  headingContainer: D,
  arrowIcon: L,
  pageTitle: W,
  menuDropdownItem: G,
  menuDropdownItemTitle: T,
  menuDropdownItemDescription: f,
  menuDropdownItemTitleWrapper: B,
  gradientText: M
};
export {
  I as activeIcon,
  a as areaOfLawImage,
  t as areaOfLawImageContainer,
  y as areasList,
  i as areasMenuModal,
  L as arrowIcon,
  p as closeButton,
  u as closeWrapper,
  C as default,
  d as defaultImage,
  n as dropdownGrid,
  _ as dropdownImageWrapper,
  M as gradientText,
  D as headingContainer,
  c as hidden,
  l as imageHidden,
  m as imageVisible,
  o as innerWrapper,
  r as mainMenuLink,
  s as menuDropdownBGIcon,
  G as menuDropdownItem,
  f as menuDropdownItemDescription,
  T as menuDropdownItemTitle,
  B as menuDropdownItemTitleWrapper,
  e as menuItemDropdown,
  g as mobileBGIcon,
  w as modalContent,
  W as pageTitle
};
